import React from 'react'
import { graphql } from 'gatsby'
import { useStaticQuery } from 'gatsby'
import { Button, Form, FormControl } from 'react-bootstrap'

import SearchContext, {SearchContextProvider} from './searchcontext'

import SearchStyles from './searchInput.module.css'

const SearchForm = ({value, handleInputChange, handleSubmit}) => {
    const { gcms } = useStaticQuery(
        graphql`
            query {
                site {
                    siteMetadata {
                        title
                    }
                }
                gcms {
                    posts(orderBy: publishedAt_DESC) {
                        id
                        createdAt
                        title
                        category
                        image {
                            url
                        }
                        slug
                        body {
                            html
                            text
                        }
                    }
                }
            }
        `
    )

    const allPosts = gcms.posts

    function handlePrevention(e) {
        e.preventDefault()
        handleSubmit(allPosts)
    }
    
    return (
        <Form inline className={SearchStyles.form} onSubmit={handlePrevention}>
            <FormControl
                className={`${SearchStyles.formInput} form-control`}
                type="search"
                placeholder="Type to filter posts..."
                aria-label="Search"
                onChange={handleInputChange}
                value={value}
            />

            <Button className={SearchStyles.formButton} type="submit">
                <span className="fa fa-search"></span>
            </Button>
        </Form>
    )
}
            
const SearchInput = (props) => {
                
    return(
        <SearchContext.Consumer>
            {context => {
                return (
                    <SearchForm {...props} {...context} />
                )}}
        </SearchContext.Consumer>
    )
}

export default SearchInput
export {SearchContext, SearchContextProvider}
